import { HTMLAttributes } from 'react'
import { AccountIcon } from 'shop/assets/icons'
import styled from '@emotion/styled'
import AccountMenu from '../Landing/AccountMenu'
import { useModal } from 'shop/hooks'

type StyledHTMLElement = React.DetailedHTMLProps<
  HTMLAttributes<HTMLElement>,
  HTMLElement
>

const LoginIcon = () => {
  const { isModalOpen, openModal, loginModal } = useModal()
  const isLoggedIn = localStorage.getItem('customerId') !== null

  const handleIconClick = () => {
    if (!isLoggedIn) {
      openModal('login')
    }
  }

  return (
    <>
      {isModalOpen('login') && !isModalOpen('fulfillment') && loginModal({})}
      <IconContainer onClick={() => handleIconClick()} data-testid='login-icon'>
        {isLoggedIn && <AccountMenu inverted />}
        {!isLoggedIn && (
          <Icon>
            <AccountIcon height='18px' width='18px' />
          </Icon>
        )}
      </IconContainer>
    </>
  )
}

const IconContainer = styled.div(({ theme }) => ({
  position: 'relative',
  cursor: 'pointer',
  height: '32px',
  width: '32px',
  WebkitTapHighlightColor: 'transparent',

  [theme.mediaQueries.viewport7]: {
    display: 'flex',
    paddingTop: '0'
  }
}))

const Icon = styled.span<StyledHTMLElement>(({ theme }) => ({
  width: '32px',
  height: '32px',
  borderRadius: theme.borderRadius,
  marginLeft: 'auto',
  backgroundColor: 'black',
  display: 'flex',
  cursor: 'pointer',
  filter: 'invert(1)',

  '&:hover': {
    opacity: 0.9
  },

  '>svg': {
    margin: 'auto'
  }
}))

export default LoginIcon
